/**
 * How a trainer fee is expressed (MV2-577): a fixed amount in the currency
 * of what it is attached to (membership, session), or a percent of the
 * collected price. A per-trainer session fee is FIXED only in Part 1.
 */
export enum TrainerFeeType {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}
